import { FC } from 'react';
import { FraudPatternView } from 'src/ts/interfaces/listCheck';
import EmbeddedFontsView from './EmbeddedFontsView';
import FallbackView from './FallbackView';
import HeaderBarsView from './HeaderBarsView';
import TextPlacementView from './TextPlacementView';
import { PatternViewProps } from './types';

const VIEWS: Record<FraudPatternView, FC<PatternViewProps>> = {
  text_placement: TextPlacementView,
  header_bars: HeaderBarsView,
  embedded_fonts: EmbeddedFontsView,
  fallback: FallbackView
};

export const viewFor = (view: string): FC<PatternViewProps> =>
  Object.keys(VIEWS).includes(view) ? VIEWS[view as FraudPatternView] : FallbackView;

export type { PatternViewProps } from './types';
